import type {} from "@lit/react";
import { Map as MapElement, } from "@vaadin/map/vaadin-map.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { MapElement, };
export type MapEventMap = Readonly<{}>;
const events = {} as MapEventMap;
export type MapProps = WebComponentProps<MapElement, MapEventMap>;
export const Map = createComponent({
    elementClass: MapElement, events, react: React, tagName: "vaadin-map"
});
